export default __webpack_public_path__ + "static/media/signature-placeholder-bk.e058eae0.svg";